import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";


//Disponiblite étendu
interface IProps {
  title: React.ReactNode;
  illustration:string;
  description:React.ReactNode;
  boostrapiconClassname:string;
  btnAccesAvailable?:boolean;
  btnAccesPath?:string;
  btnInfoAvailable?:boolean;
  btnInfoPath?:string;
}
const CpntAccueilModule: React.FC<IProps> = ({ title,illustration,description,boostrapiconClassname,btnAccesAvailable,btnAccesPath,btnInfoAvailable,btnInfoPath }) => {

    // <SpinnerEditeurPro />
    return (
        <Card className="module-card">
        <Card.Header className="text-start">
        <i className={`bi ${boostrapiconClassname}`}></i>
        </Card.Header>
        <Card.Body>
          <Card.Title>{title}</Card.Title>
            <div className="description pt-2 row">
              <div className="col-3">
                <img src={illustration} className="card-image" />
              </div>
              <div className="col-9"> 
                {description}
              </div>
          </div>
        </Card.Body>
        <Card.Footer>
            {btnAccesPath && btnAccesAvailable && <Link 
            to={btnAccesPath} 
            className={`btn ${btnAccesAvailable ? " btn-secondary" : "btn-darkgrey"} `} >
                Accéder</Link>}

            {btnInfoPath && btnInfoAvailable && <Link 
            to={btnInfoPath} 
            className={`btn ${btnInfoAvailable ? " btn-primary" : "btn-darkgrey"} `} >
                En savoir plus</Link>}
        </Card.Footer>
      </Card>
      );
    };

export default CpntAccueilModule;
